import { isError } from 'lodash';
import * as Yup from 'yup';

import { QueryParamNames } from '~/constants/search';
import { containsRestrictedPathChars } from '~/utils/FileUtils';
import { getCurrentQuery } from '~/utils/Url';

export const AssetTitleValidationSchema = Yup.object().shape({
  ['title']: Yup.string()
    .max(255, 'Cannot be longer than 255 characters')
    .required('Title is required')
    .test(
      'restricted-char-validation',
      'Characters : and | cannot be used',
      (val) => !containsRestrictedPathChars(val || ''),
    )
    .matches(/^[^\n]*$/, 'No line breaks allowed'),
});

export const validateAssetTitle = (value: string): string | undefined => {
  try {
    AssetTitleValidationSchema.validateSync({ title: value });
  } catch (error) {
    return isError(error) ? error.message : 'Invalid title';
  }
};

export const assetModalParamsToOmit: QueryParamNames[] = [
  QueryParamNames.timestamp,
  QueryParamNames.tab,
  QueryParamNames.discussionId,
  QueryParamNames.versions,
  QueryParamNames.capturedTextId,
  QueryParamNames.faceId,
  QueryParamNames.page,
];

export const getQueryWithoutAssetModalParams = () => {
  const query = getCurrentQuery();
  assetModalParamsToOmit.forEach((param) => delete query[param]);
  return query;
};
